module.exports = __webpack_public_path__ + "static/media/ITBO05.b102ba88.jpg";